import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function Login({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate(); // Initialize the navigate function

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const response = await axios.post('https://api.jimmybauduin.com/users/login', { username, password });
            const { token } = response.data;

            // Store the token and notify parent component of login
            localStorage.setItem('token', token);
            onLogin(); // Call parent handler to change login status
            navigate('/'); // Redirect to home page after successful login
        } catch (err) {
            setError('Invalid credentials');
        }
    };

    return (
        <div className="row mt-4 text-center">
            <div className="col-12 col-md-4 mx-auto">
                <h2>Admin Login</h2>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formUsername">
                        <Form.Label>Username</Form.Label>
                        <Form.Control type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    </Form.Group>
                    <Button type='submit' variant='secondary'>Login</Button>
                </Form>
            </div>
        </div>
    );
}

export default Login;
